module.exports = __webpack_public_path__ + "img/full5-min.4fee46c3.png";